module.exports = __webpack_public_path__ + "img/logo-doctor-near-me-small.a3b0d08d.png";